import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export const ChampionSpotlight = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/champions/last-week").then(({ data }) => setData(data)).catch(() => {}); }, []);
  if (!data?.champions?.length) return null;
  return (
    <section className="mx-auto max-w-7xl px-4 sm:px-8 py-14" data-testid="champion-spotlight">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-primary"><Crown size={14} /> Champion spotlight · {data.week}</p>
          <h2 className="mt-1 font-serif text-lg md:text-xl">Last week's #1 students — congratulations!</h2>
        </div>
        <div className="flex gap-5">
          <Link to="/hall-of-fame" className="text-sm text-muted-foreground hover:text-primary" data-testid="champion-hof-link">Leaderboard</Link>
          <Link to="/ear-trainer" className="group flex items-center gap-1.5 text-sm text-primary" data-testid="champion-spotlight-link">
            Take the challenge <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {data.champions.map((c) => (
          <div key={`${c.board}-${c.level}`} className="rounded-2xl border border-primary/30 bg-card p-5 transition-transform hover:-translate-y-1" data-testid={`champion-${c.board.split(" ")[0].toLowerCase()}-${c.level}`}>
            <Crown className="text-primary" size={22} />
            <p className="mt-3 font-serif text-xl">{c.name}</p>
            <p className="mt-1 text-xs text-muted-foreground">{c.board} · {c.level}</p>
            <p className="mt-2 font-mono text-[11px] uppercase tracking-widest text-primary">Best streak {c.streak}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
